export const SECONDS = 1000;

export const MINUTES = SECONDS * 60;

export const HOURS = MINUTES * 60;

export const DAYS = HOURS * 24;

export const MOSCOW_UTC_OFFSET = 3;

export const initialTimerValues = {
  hours: '00',
  minutes: '00',
  seconds: '00',
};
